
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Dialog, RegisterRouter } from "@components";
import { ApplicationLayout, Button, Sidebar } from "@rio-cloud/rio-uikit";
import { useAppSelector } from "@store";
import { CreateAreaReworkPayload, IRoute, IVehicleInfo, Route } from "@types";
import { CreateRouteCostPayload } from "../../types/costSimulator";
import { IStop } from "../RegisterRoute";

type TProps = {
  sendRoute: (
    origin: IRoute,
    destination: IRoute,
    routes: Route[],
    stops: IStop[],
    routeCost: CreateRouteCostPayload,
    value: string,
    routeRangeToleranceLimit: number | null,
    avoidToll: boolean,
    areas: CreateAreaReworkPayload[],
    vehicle: IVehicleInfo,
    distance?: string,
  ) => void;

  handleRoutes: (routes: Route[], via: any[]) => void;
  disableConfirm?: boolean;
  statusTrip?: "create" | "update";

};

const SidebarRoute = ({ sendRoute, handleRoutes, disableConfirm, statusTrip = "create" }: TProps) => {
  const [showDialog, setShowDialog] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [value, setValue] = useState("");
  const {
    origin,
    destination,
    routes,
    stops,
    routeCost,
    routeRangeToleranceLimit,
    avoidToll,
    areas,
    vehicle,
    distance
  } = useAppSelector((state) => state.routes);

  const handleClick = () => {
    if (statusTrip === "update") {
      sendRoute(
        origin!,
        destination!,
        routes,
        stops,
        routeCost,
        value,
        routeRangeToleranceLimit,
        avoidToll,
        areas,
        vehicle,
        distance
      );
      return;
    }

    if (origin && destination) {
      setShowDialog(true);
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    sendRoute(
      origin!,
      destination!,
      routes,
      stops,
      routeCost,
      value,
      routeRangeToleranceLimit,
      avoidToll,
      areas,
      vehicle,
      distance
    );
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.currentTarget.value);
    setEnableSubmit(Boolean(event.currentTarget.value));
  };

  const handleClose = () => {
    setShowDialog(false);
  };

  const navigate = useNavigate();

  return (
    <ApplicationLayout.Sidebar className="right z-index-2 height-100pct">
      <Sidebar
        title=""
        closed={false}
        headerClassName="padding-x-20"
        onClose={() => { navigate("/routing/routes") }}
        position={Sidebar.RIGHT}
        disableClose={false}
        width={580}
      >
        <div className="padding-left-20 padding-right-20">
          <RegisterRouter onChangeRoutes={handleRoutes} onSave={handleClick} />
          <Dialog.SaveName 
            showDialog={showDialog}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            handleInputChange={handleInputChange}
            disableConfirm={disableConfirm}
            enableSubmit={enableSubmit}
          />
        </div>
      </Sidebar>
    </ApplicationLayout.Sidebar>
  );
};

export default SidebarRoute;
